import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service'

@Component({
  selector: 'app-headernotlogin',
  templateUrl: './headernotlogin.component.html'
})
export class HeadernotloginComponent implements OnInit {

  public Bayer: string

  public Etiquetas: {
  
    Home: {
      HeaderImage1: string,
      HeaderImage2: string,
    } 
   
  }

  constructor(private configService: ConfigService,) { }

  ngOnInit(): void {

    this.Bayer = this.configService.uri.Bayer

    this.Etiquetas = {
      Home: 
      {
       
        HeaderImage1: this.configService.etiquetas.Home.HeaderImage1,
        HeaderImage2: this.configService.etiquetas.Home.HeaderImage2
       
      }
     
    }
  }

}
